import { PropsWithChildren } from "react";
import { Navigate } from "react-router-dom";
interface GuardedRouteProps extends PropsWithChildren {
  auth: boolean;
}
function GuardedRoute({ children, auth }: GuardedRouteProps) {
  console.log("GuardedRoute", auth);
  return auth ? <>{children}</> : <Navigate to="/" />;
}
export default GuardedRoute;
